import { useState } from 'react';
import { useCorporateAccountEstablishStore } from '../hooks';
import { useGetPdfInfoQuery } from 'views/utils/graphql/graphql';
import { InvestorCategory } from 'views/utils/enums';
import { CorporateAccountOpenProfileDetailsPages, useCorporateAccountOpenProfileDetailsPageTypeStore } from 'views/pages/accountOpenProfileDetails/corporateProfileDetails/hooks';

export type ConsentInfoType = {
  investorCategory : string,
  consentDate : string,
  downloadConsentGeneralInvestorPdf : boolean,
}

export const useConsentConfirm = () => {
    const [clicked, setClicked] = useState<boolean>(false);
    const [checked, setChecked] = useState<boolean>(false);
    const { param, add } = useCorporateAccountEstablishStore();
    const { setAccountOpenProfileDetailsPageType, setPreviousPage } = useCorporateAccountOpenProfileDetailsPageTypeStore();    

    //getpdfリクエスト state
    const [fileData, _] = useGetPdfInfoQuery({
        variables: {
            pdfName : "取り扱い承諾書",
            companyName : param.corporateName
        },
        requestPolicy: 'network-only',
      });

    const download = () => {
      const base64String = fileData.data?.GetPdfInfo?.PdfData;
      if(!base64String)return;

      // Base64文字列をデコードしてバイナリデータに変換
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      
      // Blobオブジェクトを作成
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      
      // Blob URLを生成
      const blobUrl = URL.createObjectURL(blob);
      
      // ダウンロードリンクを作成してクリックイベントを発火
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = '特定投資家以外の顧客としての取り扱い承諾書.pdf';
      link.click();
      
      // メモリリークを防ぐためにBlob URLを解放
      URL.revokeObjectURL(blobUrl);
    };

    const handleDownLoadButtonClick = () => {
      download();
      setClicked(true);
      add({
        ...param,
        ...{
          downloadConsentGeneralInvestorPdf : true
        },
      });   
    }

    const handleConsentButtonClick = () => {      
      setAccountOpenProfileDetailsPageType(CorporateAccountOpenProfileDetailsPages.tfAuthentication)
      setPreviousPage(CorporateAccountOpenProfileDetailsPages.consentConfirm)
      add({
        ...param,
        ...{
          investorCategory: InvestorCategory.GeneralInvestor,
          consentDate : fileData.data?.GetPdfInfo?.ConsentDate,
        },
      });   
    }

    const downLoadProps = {
      onClick : handleDownLoadButtonClick,
    }

    const checkBoxProps = {
      checked : checked,
      setChecked : (value : boolean) => setChecked(value),
      disabled : !clicked,
    }

    const nextProps = {
      onClick : handleConsentButtonClick,
      disable : !checked
    }

    const backProps ={
      onClick : () => setAccountOpenProfileDetailsPageType(CorporateAccountOpenProfileDetailsPages.offerConfirm),
    }

  return {
    fileData,
    downLoadProps,
    checkBoxProps,
    nextProps,
    backProps,
  };
};
